var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "flex message-user-container",
          style: { "margin-left": _vm.isFullScreen() ? "0px" : "32px" },
        },
        [
          _vm.isSensitive
            ? _c("div", { staticClass: "content-sensitive" }, [
                _c("p", [_vm._v(_vm._s(_vm.text))]),
                _c("div", { staticClass: "divider" }),
                _c("div", { staticClass: "err-item" }, [
                  _vm._m(0),
                  _c(
                    "div",
                    {
                      staticClass: "status-i add-hover",
                      on: { click: _vm.editSensitive },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/image/aigc/edit.png"),
                          alt: "",
                        },
                      }),
                      _c("span", { staticClass: "edit-span" }, [
                        _vm._v("重新编辑"),
                      ]),
                    ]
                  ),
                  _c("span", { staticClass: "err-content" }, [
                    _vm._v("包含敏感词：" + _vm._s(_vm.isSensitiveReply)),
                  ]),
                ]),
                _vm._m(1),
              ])
            : _vm._e(),
          _c("div", { staticClass: "flex user-content-message" }, [
            _c("div", { staticClass: "upload-container" }, [
              _vm.messageType === "file" &&
              !["jpg", "jpeg", "png", "bmp", "webp"].includes(_vm.format)
                ? _c("div", { staticClass: "file-card" }, [
                    _c("div", { staticClass: "file-icon" }, [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require(`@/assets/svg/file/${_vm.fileExtension}.svg`),
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "file-info" }, [
                      _c("div", { staticClass: "file-title" }, [
                        _vm._v(_vm._s(_vm.fileName)),
                      ]),
                      _c("span", { staticClass: "file-detail" }, [
                        _vm._v(
                          _vm._s(_vm.fileExtension) + " " + _vm._s(_vm.fileSize)
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm.messageType === "file" &&
              ["jpg", "jpeg", "png", "bmp", "webp"].includes(_vm.format)
                ? _c("div", { staticClass: "img-box" }, [
                    _c("img", {
                      staticClass: "upload-image",
                      attrs: { src: _vm.fileImageUrl || _vm.fileUrl },
                      on: {
                        click: function ($event) {
                          _vm.showDialog = true
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "content-container" }, [
              !_vm.isSensitive
                ? _c(
                    "div",
                    {
                      staticClass: "content",
                      on: { mousedown: _vm.allowTextSelection },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "copy-tools",
                          on: { click: _vm.copyText },
                        },
                        [
                          _c("img", {
                            staticClass: "img-default",
                            attrs: {
                              src: require("@/assets/image/aigc/copy.png"),
                              alt: "",
                            },
                          }),
                          _c("img", {
                            staticClass: "img-hover",
                            attrs: {
                              src: require("@/assets/image/aigc/copy-hover.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                      _c("p", [_vm._v(_vm._s(_vm.text))]),
                      _c("div", { staticClass: "float-op" }, [
                        _vm.customAddTemp
                          ? _c("div", {
                              staticStyle: {
                                width: "1px",
                                height: "20px",
                                "background-color": "#cccccc",
                                margin: "0 10px",
                              },
                            })
                          : _vm._e(),
                        _vm.customAddTemp
                          ? _c(
                              "div",
                              {
                                staticClass: "float-tools",
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("addTemp")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "img-default",
                                  attrs: {
                                    src: require("@/assets/image/aigc/add_temp.png"),
                                    alt: "",
                                  },
                                }),
                                _c("img", {
                                  staticClass: "img-hover",
                                  attrs: {
                                    src: require("@/assets/image/aigc/add_temp_active.png"),
                                    alt: "",
                                  },
                                }),
                                _c("div", { staticClass: "tip" }, [
                                  _vm._v("添加模版"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.isFullScreen()
                ? _c("div", { staticClass: "flex head" }, [
                    _vm._v(_vm._s(_vm.userName)),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _c("PreviewDialog", {
        attrs: {
          title: _vm.fileName,
          "img-src": _vm.fileImageUrl || _vm.fileUrl,
          visiable: _vm.showDialog,
        },
        on: {
          close: function ($event) {
            _vm.showDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "status-i" }, [
      _c("img", {
        attrs: { src: require("@/assets/image/aigc/send-err.png"), alt: "" },
      }),
      _c("span", { staticClass: "err-span" }, [_vm._v("发送失败")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "triangle" }, [
      _c("div", { staticClass: "border" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }